import { Component, Input, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { isolateDocumentHtml } from '../../utils';

/**
 * Renders server-generated HTML inside a Shadow DOM so its `<style>` blocks
 * cannot leak to the page. Document-level tags are stripped BEFORE insertion
 * via `isolateDocumentHtml`: Shadow DOM does not neutralise a
 * `<meta name="viewport">`, which Chrome applies to the whole page on
 * insertion and which collapses the Staff Site's layout viewport.
 */
@Component({
  selector: 'app-isolated-html',
  template: '<div [innerHtml]="safeContent"></div>',
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class IsolatedHtmlComponent {
  public safeContent: SafeHtml = '';

  @Input()
  set content(value: string) {
    this.safeContent = this.domSanitizer.bypassSecurityTrustHtml(
      isolateDocumentHtml(value || '')
    );
  }

  constructor(private domSanitizer: DomSanitizer) {}
}
